module.exports = __webpack_public_path__ + "static/media/PRATIC - COZINHA.6bfd8c67.pdf";